import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../redux/actions/user'
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router-dom'


export default function RattachementVerification(props) {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const history = useHistory()
  const state = useSelector(state => state)
  const { token: tokenVerification } = props.match.params
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  useEffect(() => {

    async function fetchData() {
      const result = await allActions.fetchPostAPI(`api/users/valider-rattachement/${tokenVerification}`, {}, dispatch, token)

      //Si la requête n'a pas fonctionnné une erreur est affiché
      if (result.err) {
        enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
        return
      }
  
      //Si le serveur retourne une erreur elle est affiché
      if (result?.json.err) {
        enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
        return
      }
  
      enqueueSnackbar(result.json.message, { variant: `success` })
      history.push('/')
    }

    fetchData()
    
  }, [])

  return null
}
